const law = [{
    path: "/lawList",
    name: "lawList",
    component: () =>
        import ("@/views/law/lawList.vue"),
    meta: {
        title: "普法宣传",
    }
}, {
    path: "/lawDetailOne",
    name: "lawDetailOne",
    component: () =>
        import ("@/views/law/lawDetailOne.vue"),
    meta: {
        title: "普法宣传",
    }
}, {
    path: "/lawIndex",
    name: "lawIndex",
    component: () =>
        import ("@/views/law/lawIndex.vue"),
    meta: {
        title: "普法宣传",
    }
}];
export default law;